<template>
	<page>
		<module>
			<view-list work-type="36" ref="view" selector :view-config="auth('b_outsourcing_settle_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="结算单号">
							<c-input name="settle_code"></c-input>
						</m-search-item>
						<m-search-item label="委外单号">
							<c-input name="outsourcing_code"></c-input>
						</m-search-item>
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier" ></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_outsourcing_settle_add')" v-lock="lock('b_outsourcing_settle_add')" prepend-icon="tf-add" @click="editSettle()">创建结算单</c-button>
					<c-button v-if="auth('b_outsourcing_settle_export')" v-lock="lock('b_outsourcing_settle_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_outsourcing_settle_export')" v-lock="lock('b_outsourcing_settle_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_outsourcing_settle_export')" v-lock="lock('b_outsourcing_settle_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_outsourcing_settle_export')" v-lock="lock('b_outsourcing_settle_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_outsourcing_settle_print')" v-lock="lock('b_outsourcing_settle_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>
				
				<!--委外单编号-->
				<template v-if="auth('m_outsourcing_order')" #outsourcing_code="{data}">
					<c-link @click="globalDialog('outSourcingDetail', {props: {id: data.out_sourcing_order_id}})">{{data.outsourcing_code}}</c-link>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--结算金额-->
				<template #settle_money="{data}">
					￥{{parseFloat(data.settle_money).toFixed(2)}}
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_outsourcing_settle_edit')" v-lock="lock('b_outsourcing_settle_edit')" icon="tf-edit" @click="editSettle(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_settle_print')" v-lock="lock('b_outsourcing_settle_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_outsourcing_settle_remove')" v-lock="lock('b_outsourcing_settle_remove')" icon="tf-trash" @click="removeSettle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--委外结算单编辑动态弹窗-->
			<out-sourcing-settle-edit ref="outSourcingSettleEdit" @resolve="$refs.view.update()"></out-sourcing-settle-edit>
		</module>
	</page>
</template>

<script>
	import outSourcingSettleEdit from "@/pages/supply/out_sourcing_order_settle_edit.vue";
	import outSourcingProcessEdit from "@/pages/supply/out_sourcing_order_process_edit.vue";

	export default {
		components: {
			outSourcingProcessEdit,
			outSourcingSettleEdit
		},

		data() {
			return {
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SUPPLIER',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/**
			 * 编辑委外结算单
			 */
			editSettle(data){
				this.$refs.outSourcingSettleEdit.open(data);
			},

			/******删除委外结算单************/
			removeSettle(data){
				this.$confirm({
					message:'确认删除当前委外结算单【'+data.settle_code+'】？删除后不可恢复',  // 提示内容,
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url:'/out/sourcing/settle/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>